import { getList } from 'api/cosoApi';
import { create } from 'api/facilityHazarWasteReportApi';
import slug from 'constants/slug';
import PageLockHOC from 'hoc/pageLock';
import Message from 'rc-message';
import React from 'react';
// import * as _ from 'lodash';
import FacilityHazarWasteReportForm from '../FacilityHazarWasteReportForm';

@PageLockHOC(['facilityHazarWasteReport.write'])
export default class FacilityHazarWasteReportCreate extends React.Component {
  static propTypes = {};

  state = {
    isLoaded: true,
    isLoading: false,
    facility: null,
    facilityId: '',
  };

  async checkValidate() {
    // const queryString = getQueryString(this.props.location.search);
    // const _id = queryString.facilityId;
    // console.log({ _id });
    // if (_id) {
    const res = await getList();
    if (res.success) {
      this.setState({
        facility: res.data,
        facilityId: res.data._id,
        isLoading: false,
        isLoaded: true,
      });
    }
    // } else {
    //this.props.history.push(slug.CO_SO.LIST);
    // }
  }

  async componentWillMount() {
    await this.checkValidate();
  }

  handelSubmit = async (values) => {
    this.setState({
      isLoading: true,
    });
    const res = await create(_.pickBy(values, _.identity));
    if (res.success && res.data) {
      Message.success({ content: 'Thành Công' });
      this.props.history.push(
        slug.HAZARDOUS_WASTE_REPORT.VIEW_WITH_ID + res.data._id
      );
    }
    if (res.error) Message.error({ content: res.message });
  };

  render() {
    return (
      <div>
        {this.state.isLoaded && (
          <FacilityHazarWasteReportForm
            slugBack={slug.HAZARDOUS_WASTE_REPORT.LIST}
            handelSubmit={this.handelSubmit}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/FacilityHazarWasteReportContainer/FacilityHazarWasteReportCreate/index.js